// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
  requestSent: path(ROOTS_AUTH, '/request-sent'),
};

export const PATH_PAGE = {
  home: '/home',
  shipperWelcome: '/shipper-welcome',
  acquisition: '/acquisition',
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  guestOrdersDeliveryView: (token) => path(`/track-deliveries/${token}`),
  guestOrderDeliveryView: (token) => path(`/track-delivery/${token}`),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  retailer: {
    hq: {
      dashboard: (anchoLink = 'deliveriesSummaryReport') => path(ROOTS_DASHBOARD, `/retailer-hq/home#${anchoLink}`),
      allDeliveries: path(ROOTS_DASHBOARD, '/retailer-hq/all-deliveries'),
      reports: path(ROOTS_DASHBOARD, '/retailer-hq/report'),
      mySuppliers: path(ROOTS_DASHBOARD, '/retailer-hq/my-suppliers'),
      users: {
        new: path(ROOTS_DASHBOARD, '/users/retailer/new'),
        list: path(ROOTS_DASHBOARD, '/users/retailer/list'),
        account: path(ROOTS_DASHBOARD, '/users/retailer/account'),
        edit: (id) => path(ROOTS_DASHBOARD, `/users/retailer/${id}/edit`),
      },
    },
    outlet: {
      deliveries: path(ROOTS_DASHBOARD, '/branch/deliveries'),
      users: {
        new: path(ROOTS_DASHBOARD, '/users/retailer/new'),
        list: path(ROOTS_DASHBOARD, '/users/retailer/list'),
        account: path(ROOTS_DASHBOARD, '/users/retailer/account'),
        edit: (id) => path(ROOTS_DASHBOARD, `/users/retailer/${id}/edit`),
      },
    },
  },
  // retailers/deliveryTracking/ReportDeliveries
  tms: {
    retailers: {
      deliverySummary: path(ROOTS_DASHBOARD, '/retailers/delivery-summary'),
      allDeliveries: path(ROOTS_DASHBOARD, '/retailers/all-deliveries'),
      // viewOrderDetails: path(ROOTS_DASHBOARD, `/retailers/orders/custom-order-view`),
      analytics: path(ROOTS_DASHBOARD, '/retailers/analytics'),
    },
    users: {
      new: path(ROOTS_DASHBOARD, '/users/retailer/new'),
      list: path(ROOTS_DASHBOARD, '/users/retailer/list'),
      account: path(ROOTS_DASHBOARD, '/users/retailer/account'),
      edit: (id) => path(ROOTS_DASHBOARD, `/users/retailer/${id}/edit`),
    },
    shippers: {
      onboard: path(ROOTS_DASHBOARD, '/shipper/new'),
      schedulePickup: (viewType) => path(ROOTS_DASHBOARD, `/schedule-pickup/${viewType}`),
      editSchedulePickup: (orderId) => path(ROOTS_DASHBOARD, `/schedule-pickup/${orderId}/edit`),
      packaging: path(ROOTS_DASHBOARD, '/packaging/new'),
      deliveryNotes: path(ROOTS_DASHBOARD, '/delivery-notes'),
      submittedRequests: path(ROOTS_AUTH, '/submittedRequests'),
      worksheet: (pickupDate, { reuse = false }) => path(ROOTS_DASHBOARD, `/worksheet/${pickupDate}?reuse=${reuse}`),
      pickupRequest: (view) => path(ROOTS_DASHBOARD, `/pickup-requests/${view}`),
    },
    dnote: {
      new: path(ROOTS_DASHBOARD, '/dnote/new'),
      view: (id) => path(ROOTS_DASHBOARD, `/dnote/${id}`),
      edit: (id) => path(ROOTS_DASHBOARD, `/dnote/${id}/edit`),
      generateDnote: (orderId) => path(ROOTS_DASHBOARD, `/generate-delivery-note/${orderId}`),
    },
    deliveries: {
      orderTracking: path(ROOTS_DASHBOARD, '/deliveries-tracking'),
      view: (id) => path(ROOTS_DASHBOARD, `/delivery-tracking/${id}`),
    },
    billingInfo: path(ROOTS_DASHBOARD, '/billing-info'),
    invoiceList: path(ROOTS_DASHBOARD, '/invoice-list'),
    invoicing: path(ROOTS_DASHBOARD, '/invoicing'),
    returns: {
      root: path(ROOTS_DASHBOARD, '/returns'),
      view: (id) => path(ROOTS_DASHBOARD, `/returns/${id}`),
      single_view: (id) => path(ROOTS_DASHBOARD, `/returns/${id}/view`),
      deliveries: path(ROOTS_DASHBOARD, '/returns/deliveries'),
      scheduleReturns: (orderId) => path(ROOTS_DASHBOARD, `/returns/schedule${!orderId ? '' : `?orderId=${orderId}`}`),
      editScheduledReturn: ({ returnDocRefId, orderId }) =>
        path(ROOTS_DASHBOARD, `/returns/edit?returnDocReferenceId=${returnDocRefId}&orderId=${orderId}`),
      waybills: path(ROOTS_DASHBOARD, '/returns/waybills'),
      items: path(ROOTS_DASHBOARD, '/returns/items'),
      note: (id) => path(ROOTS_DASHBOARD, `/returns/${id}/note`),
    },
    customerGraph: path(ROOTS_DASHBOARD, '/customer-graph'),
    feedback: path(ROOTS_DASHBOARD, '/feedback'),
    modelInferencing: path(ROOTS_DASHBOARD, '/model-inferencing'),
    pickupSchedule: path(ROOTS_DASHBOARD, '/pickup-schedule'),
  },
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
